// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","root":"EO1HFjiFjxxRMR2gVpis","wrap":"P0qUNFxKgzkfPNmrzcNM","main":"rBH1KNcaS0k2IeguMh3x"};